// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__nIDNe","description--expanded":"styles_description--expanded__hxcAI"};